import { m as mulberry32 } from './mulberry32-e194cf38-1bf4e008.js';

/**
 * Create random 16 character strings that are suitable for ephemeral HTML ids. These are *NOT*
 * guaranteed to be unique. Just likely to be unique enough for a single HTML page.
 */

/*
 * Random number picked by 20d dice roll.
 * changing this seed will break the snapshots of any components that use PUIDs
 */
const seed = 5;

/*
 * Characters safe to use in HTML5 ids
 */
const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

/*
 * Some types to make typescript happy.
 */

/*
 * Pull Math.random() into scope
 */
let {
  random
} = Math;

/*
 * Use the PRNG to create deterministic ids when we detect a jest test environment,
 * jest sets the `JEST_WORKER_ID` env when running tests
 */
if (typeof process === 'object' && typeof process.env === 'object' && typeof process.env.JEST_WORKER_ID === 'string') {
  /*
   * Replace the random() we use with the mulberry32 PRNG + seed
   */
  random = mulberry32(seed);
}
function createPseudoUID() {
  let result = '';
  for (let i = 0; i < 16; i++) {
    result += characters.charAt(Math.floor(random() * characters.length));
  }
  return result;
}

export { createPseudoUID as c };
//# sourceMappingURL=createPseudoUID-090182c8-77d923ce.js.map
